import { useEffect, useState } from "react";
import {Box, Typography, FormControl, OutlinedInput, InputAdornment, InputLabel, Grid, Popper , MenuItem, ImageListItem, ImageListItemBar, ImageList, CircularProgress, Select, Button, TextField, InputBase, Stack} from "@mui/material"
import VideocamIcon from '@mui/icons-material/Videocam';
import Chip from '@mui/material/Chip';
import Avatar from '@mui/material/Avatar';
import './stockModal.scss';


export const PexelsVideoModal = (props) => {
  const {stockData} = props;
  const renderDuration = (duration) =>{
    let subtitle = "";
    const minute = Math.floor(duration / 60);
    const second = Math.round((duration - minute * 60));
    subtitle += `   ${minute.toString().padStart(2, '0')}:${second.toString().padStart(2, '0')}  `;
    return subtitle;
  }
  const [showThumb, setShowThumb] = useState("");
  const [mousePosition, setMousePosition] = useState({x: null, y: null})
  const handleShowThumb = (e) => {
    setShowThumb(e);
  } 
  useEffect(() => {
    const updateMousePosition = (e) => {
      setMousePosition({ x: e.clientX, y: e.clientY });
    };
  
    window.addEventListener("mousemove", updateMousePosition);
    return () => window.removeEventListener("mousemove", updateMousePosition);
  }, []);

  let totalVideoThumbnailNum = 0;
  for (let i = 0; i < stockData.video_pictures.length; i++) {
    totalVideoThumbnailNum = i;
  }
  return (
    <Box >
      <Grid container spacing={3}>
        <Grid item md={4} xs={12} >
          <Typography id="spring-modal-title" variant="h6" component="h2">
            Pexels Stock Video
          </Typography>
          <Typography variant="overline" component={'p'}>
            Width: <b>{stockData?.width}</b>
          </Typography>
          <Typography variant="overline" component={'p'}>
            Height: <b>{stockData?.height}</b>
          </Typography>
          <Typography variant="overline" component={'p'}>
            Duration: <b>{stockData?.duration}</b>
          </Typography>
          <Typography variant="overline" component={'p'}>
            User: <b>{stockData?.user.name}</b>
          </Typography>
        </Grid>
        <Grid item md={8} xs={12}>
          <div style={{position: 'relative'}} className="stock-modal-media-wrapper">
            {showThumb ? 
            <img src={showThumb.target.src}/> : 
            <video muted src={stockData?.video_files[0].link}></video>}
            <div className='stockMediaBar'>
              <Stack direction='row' justifyContent='start' alignItems='center'>
                <VideocamIcon sx={{ color: 'white' }}/>
                <Typography color={'white'} variant='span'>{renderDuration(stockData?.duration)}</Typography>
              </Stack>
            </div>
          </div>
        </Grid>
        <Grid item xs={12} className="tiny-thumbnails">
          <Stack sx={{overflow: 'hidden',borderRadius: 1, cursor: 'crosshair'}} direction={'row'} justifyContent={'center'} alignItems={'center'}>
            {stockData?.video_pictures.map((e, i) => {
              return <img key={e.id} src={e.picture} style={{height: '50px', border: '1px', objectFit:'cover', width: 100 / totalVideoThumbnailNum +'%'}} onMouseOver={handleShowThumb} onMouseLeave={() => setShowThumb("")}/>
            })}
          </Stack>
        </Grid>
      </Grid>
    </Box>
  )
}